// On-chain R₿L payment helpers (PRO lifetime via wallet transfer to treasury).
import { API } from "../lib/api";

export const RBL_CONTRACT = "0xf9214b42c4c53791846E90066E52D7306adFACf5";
export const TREASURY_WALLET = "0x0f68082fE485B5763666C73629c11A12Fb777BB5";

export const rblTransferAbi = [
  {
    name: "transfer",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      { name: "to", type: "address" },
      { name: "amount", type: "uint256" },
    ],
    outputs: [{ name: "", type: "bool" }],
  },
  {
    name: "balanceOf",
    type: "function",
    stateMutability: "view",
    inputs: [{ name: "owner", type: "address" }],
    outputs: [{ name: "", type: "uint256" }],
  },
];

/** Backend quote: { usd_total, usd_full, discount_pct, rbl_required, amount_wei, ... } */
export async function getPROQuote() {
  const r = await fetch(`${API}/pro/rbl-onchain-price`);
  if (!r.ok) throw new Error("quote_unavailable");
  return r.json();
}

/** Verify TX on-chain (backend) and activate lifetime PRO. */
export async function activatePROAfterPayment({ txHash, walletAddress, token }) {
  const r = await fetch(`${API}/pro/activate-rbl`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ tx_hash: txHash, wallet_address: walletAddress }),
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) {
    const det = d?.detail || {};
    throw new Error(det?.error || det?.message || "activation_failed");
  }
  return d;
}
